"use client";

import { usePathname } from "next/navigation";
import { useCallback, useState } from "react";

import { useFiltersStore } from "../stores/filters.store";
import { parseCatalogRoute } from "../types/catalogRoute.helper";
import type { PendingFilters } from "../types/filters.type";
import { useFilterParams } from "./useFilterParams.hook";
import { useFiltersQuery } from "./useFiltersQuery.hook";

export function useMoreFilters() {
  const [isOpen, setIsOpen] = useState(false);
  const { facets, total } = useFiltersQuery();
  const [filterParams] = useFilterParams();
  const pathname = usePathname();

  const openDrawer = useCallback(() => {
    useFiltersStore.getState().initDraft(facets, total);

    const params = Object.fromEntries(
      Object.entries(filterParams).filter(([, v]) => v != null),
    ) as PendingFilters;

    // Category drill routes (/c/, /b/<marca>) embed the active category in
    // the URL path, not in query params. Populate pending_category_path so chips
    // render correctly. On /b the brand stays locked in the base prefix.
    const route = parseCatalogRoute(pathname);
    if (route.isCategoryDrill && route.categoryPath) {
      params.pending_category_path = route.categoryPath;
    }

    useFiltersStore.getState().initPendingFilters(params);
    setIsOpen(true);
  }, [facets, total, filterParams, pathname]);

  const closeDrawer = useCallback(() => {
    useFiltersStore.getState().discardDraft();
    setIsOpen(false);
  }, []);

  return { isOpen, openDrawer, closeDrawer };
}
